module.exports = __webpack_public_path__ + "h5/img/global_xjp.ec383d84.png";